'use strict';

var MarketPOSFilterFactory = function MarketPOSFilterFactory(DataFilter) {
  function MarketPOSFilter() {
    this.sourceType = ['market-product-group', 'market', 'service'];
    this.filterType = 'pos';
  }
  MarketPOSFilter.constructor = MarketPOSFilter;
  MarketPOSFilter.prototype = Object.create(DataFilter.prototype);
  MarketPOSFilter.prototype.groupBy = 'posName';
  return MarketPOSFilter;
};
MarketPOSFilterFactory.$inject = ['DataFilterFactory'];
module.exports = MarketPOSFilterFactory;